import YouberContract from './Youber';

export const CONTRACT_ORG_MAP = {
  1: YouberContract,
};
